module.exports = __webpack_public_path__ + "static/media/PHE_Temperature_Sensor_1.034e891f.svg";